import { Dropzone } from './Dropzone';
import { FileChip } from './FileChip';

interface Props {
  tenantId: string;
  onTenantIdChange: (v: string) => void;
  file: File | null;
  onFileSelected: (file: File) => void;
  onFileRemoved: () => void;
  onScan: () => void;
  scanning: boolean;
}

export function UploadStep({
  tenantId,
  onTenantIdChange,
  file,
  onFileSelected,
  onFileRemoved,
  onScan,
  scanning,
}: Props) {
  return (
    <div className="card">
      <h2 className="card-title">Enviar Documento</h2>

      <div className="tenant-row">
        <label htmlFor="tenant-id">ID da Organização</label>
        <input
          id="tenant-id"
          type="text"
          value={tenantId}
          onChange={(e) => onTenantIdChange(e.target.value)}
          placeholder="ex: minha-empresa"
        />
      </div>

      <Dropzone onFileSelected={onFileSelected} />

      {file && <FileChip file={file} onRemove={onFileRemoved} />}

      <div className="actions">
        <button
          className="btn btn-primary"
          disabled={!file || scanning}
          onClick={onScan}
        >
          {scanning ? <><span className="spinner" />Analisando documento…</> : 'Analisar Dados Sensíveis'}
        </button>
      </div>
    </div>
  );
}
